export default __webpack_public_path__ + "static/media/aljaber.6ea7d8fd.png";